import isEmpty from "lodash/isEmpty";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useLazyQuery } from "@stadium/services/apollo-client";

import { fetchDummyStore } from "@graphql/queries/stores/dummy-store";
import { setStore } from "@slices/store";
import { getUpdatedDummyStoreFields } from "@helpers/create-shop";
import { getDummyStoreDetails, getStoreBanner, getStoreUpcharge } from "@selectors/store";

import { DEMO_MODE_STORE_CURRENCY_OPTIONS } from "@constants/store";

const useFetchDummyStore = () => {
  const dispatch = useDispatch();
  const storeBanner = useSelector(getStoreBanner);
  const storeUpcharge = useSelector(getStoreUpcharge);
  const fetchedDummyStoreData = useSelector(getDummyStoreDetails);

  const [fetchStore, { data, loading }] = useLazyQuery(fetchDummyStore);

  const dummyStore = data?.dummyStore;

  useEffect(() => {
    if (!isEmpty(dummyStore)) {
      const isUpdating = !isEmpty(fetchedDummyStoreData);
      const { catalogLogoUrl, catalogLogoId, banner, currency } = dummyStore;
      const currencyConfig = DEMO_MODE_STORE_CURRENCY_OPTIONS[currency];

      dispatch(
        setStore({
          ...getUpdatedDummyStoreFields(dummyStore),
          config: {
            ...currencyConfig,
            upcharge: storeUpcharge,
          },
          ...(!storeBanner && { banner }),
          ...(!isUpdating && { catalogLogoUrl, catalogLogoId }),
        }),
      );
    }
  }, [dummyStore, loading]);

  return {
    dummyStore,
    fetchDummyStore: fetchStore,
    loading,
  };
};

export default useFetchDummyStore;
